import ApiService from '@/modules/api/services/ApiService'

const state = {
  responseState: null
}
const getters = {
  getDecathlonResponse: state => state.responseState
}

const actions = {
  async checkDecathlonId({ commit }, payload) {
      const { id, userId } = payload
    try {
      const url = `users/${userId}/decathlon/${id}`
      const data = await ApiService.save(url)
      commit('setResponse', data)
      commit(
        'setUserCardStatusDecathlon',
        data
      )
      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async deleteDecathlonId({ commit }, payload) {
      const { userId } = payload

    try {
      const url = `users/${userId}/decathlon`
      await ApiService.delete(url)
      commit('setResponse', null)
      commit(
        'setUserCardStatusDecathlon',
        null
      )
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  clearDecathlonResponseAction({ commit }) {
    commit('clearDecathlonResponse')
  }
}

const mutations = {
  setResponse(state, { data }) {
    state.responseState = data
  },
  clearDecathlonResponse(state) {
    state.responseState = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
